
import DOMReady from "./util/dom-ready";
import MicroModal from 'micromodal';  // es6 module
import CardHelper from "./card-helper";
// import BioSearch from "../../template-parts/blocks/bios";
// import FastSearch from "../../template-parts/components/search/search";

DOMReady(() => {
    // TODO: This needs to be true on storybook, but false on live.  Need to move to an environment variable
    console.log('EVENT', event)
    if (!event.isTrusted) {
      return
    }
    CardHelper.init();
    MicroModal.init();
});
